
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.424 3.302h-2.333V1.834c0-.648-.523-1.174-1.167-1.174H4.091c-.644 0-1.167.526-1.167 1.174v1.468H.591a.585.585 0 00-.583.587v.588c0 .08.065.146.145.146h1.101l.45 9.598c.03.626.544 1.12 1.166 1.12h8.276c.623 0 1.135-.492 1.164-1.12l.45-9.598h1.102c.08 0 .146-.066.146-.146v-.588a.585.585 0 00-.584-.587zm-3.646 0H4.237V1.981h5.541v1.321z"}})])
          )
        }
      }
    